module.exports = __webpack_public_path__ + "static/img/SFU老师_Paul.66a3020.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU老师_Paul.png
// module id = FfOY
// module chunks = 0